package com.devi3east.bashbuddy.preferences

import com.russhwolf.settings.Settings

class AppPreferencesImpl(
    private val settingsFactory: MultiplatformSettingsFactory
) : AppPreferences {

    private val settings: Settings by lazy {
        settingsFactory.getSettings()
    }

    override fun clear() {
        settings.clear()
    }

    // Generic methods
    override fun getInt(key: String, defaultValue: Int) = settings.getInt(key, defaultValue)
    override fun getIntOrNull(key: String) = settings.getIntOrNull(key)
    override fun getLong(key: String, defaultValue: Long) = settings.getLong(key, defaultValue)
    override fun getLongOrNull(key: String) = settings.getLongOrNull(key)
    override fun getString(key: String, defaultValue: String) = settings.getString(key, defaultValue)
    override fun getStringOrNull(key: String) = settings.getStringOrNull(key)
    override fun getBoolean(key: String, defaultValue: Boolean) = settings.getBoolean(key, defaultValue)
    override fun getBooleanOrNull(key: String) = settings.getBooleanOrNull(key)
    override fun putInt(key: String, value: Int) = settings.putInt(key, value)
    override fun putString(key: String, value: String) = settings.putString(key, value)
    override fun putLong(key: String, value: Long) = settings.putLong(key, value)
    override fun putBoolean(key: String, value: Boolean) = settings.putBoolean(key, value)
    override fun hasKey(key: String) = settings.hasKey(key)
    override fun remove(key: String) = settings.remove(key)

    // Auth-specific keys
    private val TOKEN_KEY = "jwt"
    private val EMAIL_KEY = "email"

    override fun getToken(): String? = settings.getStringOrNull(TOKEN_KEY)

    override fun saveToken(token: String) {
        settings.putString(TOKEN_KEY, token)
    }

    override fun clearToken() {
        settings.remove(TOKEN_KEY)
    }

    override fun getEmail(): String? = settings.getStringOrNull(EMAIL_KEY)

    override fun saveEmail(email: String) {
        settings.putString(EMAIL_KEY, email)
    }

    override fun clearEmail() {
        settings.remove(EMAIL_KEY)
    }
}
